import { shadowComponentType, makeShadowComponent } from 'src/sdk-components/ShadowComponent';
import Scene from '../../scene';

import { MpSdk } from 'src/types';

class SceneShadow extends Scene {
  constructor(mpSDK: MpSdk) {
    super(mpSDK);
  }

  async init() {
    await this.mpSDK.Scene.register(shadowComponentType, makeShadowComponent);
  }

  async create(data: any) {
    const modelNode = await this.scene.createNode();
    const component = modelNode.addComponent(shadowComponentType, {
      opacity: data.shadowIntensity,
    });
    modelNode.start();
    return [modelNode, component];
  }
}

export default SceneShadow;
